import { IconCashBanknote } from "@tabler/icons-react";
import { cn } from "@/lib/cn";
import { Skeleton, ThemeIcon } from "@/components/ui";
import { formatearMonto } from "@/shared/format/money";
import { useMisEstadisticas } from "../hooks/use-mis-estadisticas";
import { Sparkline } from "./Sparkline";

/**
 * Monto total (suma de Total del CFDI) de las solicitudes en flujo de
 * autorización · contexto financiero de "cuánto tengo retenido pendiente de
 * visto bueno". Diseño alineado a la KpiCard de referencia (rounded-2xl, valor
 * extrabold + subtítulo). v22 · multi-moneda (una fila por divisa).
 */
export function MontoEnAutorizacionCard() {
  const { data, isPending } = useMisEstadisticas();
  const montos = data?.montosEnAutorizacion ?? [];
  const enFlujo = data?.enFlujoAutorizacion ?? 0;
  const tieneMontos = montos.length > 0;
  const esAutorizador = data?.audiencia === "Autorizador";

  const subtitulo = esAutorizador
    ? enFlujo === 0
      ? "Tu bandeja está vacía"
      : enFlujo === 1
        ? "1 solicitud esperando tu decisión"
        : `${enFlujo} solicitudes esperando tu decisión`
    : enFlujo === 0
      ? "Sin solicitudes en flujo"
      : enFlujo === 1
        ? "1 solicitud esperando autorización"
        : `${enFlujo} solicitudes esperando autorización`;

  return (
    <div className="flex h-full flex-col rounded-2xl border border-border bg-card p-4 shadow-2xs">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
          {esAutorizador ? "Monto pendiente de autorizar" : "Monto en autorización"}
        </span>
        <ThemeIcon variant="light" color="slate" size="sm">
          <IconCashBanknote size={14} stroke={1.9} />
        </ThemeIcon>
      </div>

      <div className="mt-1 min-w-0">
        {isPending ? (
          <Skeleton height={28} width={110} />
        ) : tieneMontos ? (
          <div className="space-y-0.5">
            {montos.map(({ moneda, monto }) => (
              <div
                key={moneda}
                className={cn(
                  "font-extrabold tracking-tight text-ink-900 tabular-nums lining-nums dark:text-ink-100",
                  montos.length === 1 ? "text-2xl" : "text-lg",
                )}
              >
                {formatearMonto(monto, moneda, { maximumFractionDigits: 0, currencyDisplay: "code" })}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-2xl font-extrabold text-muted-foreground">—</div>
        )}
        <div className="mt-0.5 text-[11px] font-medium text-muted-foreground">{subtitulo}</div>
      </div>

      {/* Sparkline decorativo · ancho completo (centrado) y anclado al fondo.
          Violeta (`--blueviolet-100` de la paleta, §15) · hue único, no lo usa
          ningún otro card (naranja=activas, ámbar=requieren, verde=autorizadas,
          azul=pólizas, slate=próximas). */}
      <Sparkline shape="b" color="#9145ff" className="mt-auto h-14 w-full pt-3" />
    </div>
  );
}
